module.exports = __webpack_public_path__ + "media/pose-check.c3d81e53.mp3";